import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyTakeaway } from '../../data/checklistData';

interface PlaybookTakeawayCardProps {
  takeaway: KeyTakeaway;
  index: number;
  onClick?: (sectionId?: string) => void;
}

/** Single takeaway row. Shared between the tile and the "view all" dialog so both
 *  render in an identical style. */
const PlaybookTakeawayCard: React.FC<PlaybookTakeawayCardProps> = ({ takeaway, index, onClick }) => {
  const { t } = useTranslation();
  const clickable = !!takeaway.sectionId && !!onClick;

  return (
    <div
      className={`playbook-takeaway${clickable ? ' playbook-takeaway--clickable' : ''}`}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onClick={() => clickable && onClick?.(takeaway.sectionId)}
      onKeyDown={(e) => {
        if (clickable && (e.key === 'Enter' || e.key === ' ')) onClick?.(takeaway.sectionId);
      }}
    >
      <span className="playbook-takeaway__number">{index + 1}</span>
      <div className="playbook-takeaway__body">
        <p className="playbook-takeaway__title">{t(takeaway.titleKey)}</p>
        <p className="playbook-takeaway__desc">{t(takeaway.descriptionKey)}</p>
      </div>
    </div>
  );
};

export default PlaybookTakeawayCard;
